import type { LocationCreateSchema } from '@repo/schemas/location/locationCreate';
import type { LocationPublic } from '@repo/types/locations';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { LocationKey } from './keys';
import { LocationService } from './locationService';

export function usePostLocation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: LocationCreateSchema) => LocationService.postLocation(data).then((response) => response.data),

    onSuccess: (data) => {
      queryClient.setQueryData([LocationKey.LOCATIONS], (curr?: LocationPublic[]) => {
        if (!curr) {
          return;
        }
        return [...curr, data];
      });
      queryClient.invalidateQueries({
        queryKey: [LocationKey.LOCATIONS],
      });
    },
  });
}
